import { render, staticRenderFns } from "./ClientHeader.vue?vue&type=template&id=7f23fb68&scoped=true&"
import script from "./ClientHeader.vue?vue&type=script&lang=js&"
export * from "./ClientHeader.vue?vue&type=script&lang=js&"
import style0 from "./ClientHeader.vue?vue&type=style&index=0&id=7f23fb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f23fb68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f23fb68')) {
      api.createRecord('7f23fb68', component.options)
    } else {
      api.reload('7f23fb68', component.options)
    }
    module.hot.accept("./ClientHeader.vue?vue&type=template&id=7f23fb68&scoped=true&", function () {
      api.rerender('7f23fb68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/Client/ClientHeader.vue"
export default component.exports